export default {"src":"/_next/static/media/resource-circular-icon.d807090b.svg","height":138,"width":135,"blurWidth":0,"blurHeight":0};